// extracted by mini-css-extract-plugin
module.exports = {"report-errors-alert":"Report_report-errors-alert__1N5yn","reportErrorsAlert":"Report_report-errors-alert__1N5yn"};